import { type FullMode } from 'core/domain/Mode'
import { isPast } from 'core/utils/date'

import { type Attachment } from './Attachment'
import { type CapacityTimePeriod } from './CapacityTimePeriod'
import { type Currency } from './Currency'
import { type DistanceUnit } from './DistanceUnit'
import { type Mode } from './Mode'
import { type RequestForProposalState } from './RequestForProposalState'

export type RequestForProposal = {
  id: number
  attachments: Array<Attachment>
  canReceiveProposals: boolean
  capacityTimePeriod: CapacityTimePeriod
  contractEnd: string
  contractStart: string
  conversionRate?: string
  currency: Currency
  deleted: boolean
  distanceUnit: DistanceUnit
  enableCarrierFeedback?: boolean
  mode: Mode
  name: string
  requestDeadline: string
  shipperEmail: string
  shipperLogo?: string
  shipperName: string
  shipperPhone: string
  state: RequestForProposalState
  wasFinalized: boolean
}

export function isRfpAwarding({ state }: RequestForProposal): boolean {
  return state === 'awarding'
}

export function isRfpDeleted({ deleted }: RequestForProposal): boolean {
  return deleted
}

export function isRfpExpired({ requestDeadline }: RequestForProposal): boolean {
  return isPast(new Date(requestDeadline))
}

export function isRfpFinalized({ wasFinalized }: RequestForProposal): boolean {
  return wasFinalized
}

export function isDrayageMode(mode: Mode | FullMode): boolean {
  return mode === 'drayage'
}

export function isMultiCurrency(currency: Currency): boolean {
  return currency !== 'USD'
}
